// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";

// ** Utils & Helpers
import { LANG } from "helpers/constants";

// #####################################################
const NotificationLanguage = ({ state, dispatch }) => {
	const { t } = useTranslation(["common", "userpanel"]);

	const languageItems = LANG.map((item) => ({
		...item,
		value: item.value,
		content: item.langName,
	}));

	// #####################################################

	return (
		<Block flex column>
			<SelectorSelectSingle
				label={t(
					"userpanel:settings.preferences.notifications.language",
				)}
				items={languageItems}
				selected={state.notificationLanguage}
				onAccept={(value) => {
					if (value === null) {
						return;
					}

					dispatch({
						type: "SET_VALUE",
						field: "notificationLanguage",
						value: value,
					});
				}}
				withMobileVersion
				activatorStyleOptions={{
					noPad: true,
					noTopMargin: true,
					flex1: true,
					noFullWidth: true,
				}}
			/>
		</Block>
	);
};

// #####################################################

export default NotificationLanguage;

// #####################################################
